'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.factory('languageService', function(cookieService) {
  return {
    setLanguage: function setLanguage(language) {
      if (window.setLocale) {
        window.setLocale(language);
        window.dispatchEvent(new Event('language-switched'), 1300);
      } else {
        cookieService.setLanguageCookie(language);
      }
    },
    checkLanguageURLParam: function checkLanguageURLParam(url) {
      const language = new URLSearchParams(url.split('?')[1]).get('lang');

      if (language) {
        this.setLanguage(language);
      }
    }
  };
});
